import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Restaurant {
  id: string;
  name: string;
  organizationId: string;
  isActive: boolean;
  createdAt: string;
}

interface RestaurantState {
  currentRestaurant: Restaurant | null;
  restaurants: Restaurant[];
  loading: boolean;
  error: string | null;
}

const initialState: RestaurantState = {
  currentRestaurant: null,
  restaurants: [],
  loading: false,
  error: null,
};

const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    setCurrentRestaurant: (state, action: PayloadAction<Restaurant>) => {
      state.currentRestaurant = action.payload;
      localStorage.setItem('currentRestaurant', JSON.stringify(action.payload));
    },
    clearCurrentRestaurant: (state) => {
      state.currentRestaurant = null;
      localStorage.removeItem('currentRestaurant');
    },
    setRestaurants: (state, action: PayloadAction<Restaurant[]>) => {
      state.restaurants = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setCurrentRestaurant,
  clearCurrentRestaurant,
  setRestaurants,
  setLoading,
  setError,
  clearError,
} = restaurantSlice.actions;

export default restaurantSlice.reducer;